import { PivotSpinnerService } from '@core/services/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MultipleSpinnerService {
  private countLoading = 0;
  private isFirstTimeAccess = true;
  constructor(private pivotSpinnerService: PivotSpinnerService) { }

  show() {
    this.countLoading++;
    this.pivotSpinnerService.isFirstTime = this.isFirstTimeAccess;
    this.pivotSpinnerService.show();
    this.isFirstTimeAccess = false;
  }

  hide() {
    this.countLoading--;
    if (this.countLoading === 0) {
      this.pivotSpinnerService.hide();
    } else if (this.countLoading < 0) {
      throw new Error('countLoading cannot be less than 0');
    }
  }
}
